import { API_BASE } from '../config/api';
import { buildUrl, contextAwareHeaders } from './apiClient';

const handleResponse = async (response, fallbackMessage = 'Unable to load tournament admins.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const fetchAssignedAdminTournaments = async (token) => {
  const response = await fetch(buildUrl('/api/tournament-admin/tournaments'), {
    headers: contextAwareHeaders({ Authorization: `Bearer ${token}` }),
  });

  return handleResponse(response, 'Unable to load assigned tournaments.');
};

export const createTournamentAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/tournament-admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create tournament admin.');
};

export const updateTournamentAdmin = async (adminId, payload, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/tournament-admins/${adminId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to update tournament admin.');
};

export const deleteTournamentAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/tournament-admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete tournament admin.');
};

export const unassignOrganizationTournamentAdminRole = async (organizationId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/${organizationId}/roles/tournament-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove tournament admin role.');
};

export const unassignOrganizationDepartmentAdminRole = async (organizationId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/organizations/${organizationId}/roles/department-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove department admin role.');
};
